export default function isPickingCardByInstance(state, instance) {
  const instanceState = state.games.whoisit.instances.find(({ entity }) => entity.id === instance.id);
  return !!instanceState?.isPickingCard;
}
